import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import GnlYetkitanimDTO from "src/models/Base/Yetki/GnlYetkitanimDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { GridRowId } from '@mui/x-data-grid-premium';

interface IYetkiTanim {
    yetkiler: GnlYetkitanimDTO[]
    open: boolean;
    activeRow: GnlYetkitanimDTO;
    expandedRows: Record<GridRowId, boolean>;
}

export const YetkiTanimSlice = createSlice<IYetkiTanim, MapReducerPayloads<IYetkiTanim, {
    setYetkiler: GnlYetkitanimDTO[]
    setOpen: boolean,
    setActiveRow: GnlYetkitanimDTO
    setExpandedRows: Record<GridRowId, boolean>

}>>({

    name: "yetkiTanim",
    initialState: {
        yetkiler: [],
        open: false,
        activeRow: new GnlYetkitanimDTO(),
        expandedRows: {},
    },

    reducers: {
        setYetkiler: (state, action) => {
            state.yetkiler = action.payload;
        },
        setOpen: (state, action) => {
            state.open = action.payload;
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload;
        },
        setExpandedRows: (state, action) => {
            state.expandedRows = action.payload;
        },
    }
});

export default YetkiTanimSlice;